import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=c03a6b72&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c03a6b72')) {
      api.createRecord('c03a6b72', component.options)
    } else {
      api.reload('c03a6b72', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=c03a6b72&", function () {
      api.rerender('c03a6b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/comp/starrating.vue"
export default component.exports